import React from "react";
import {
  FaGlobe,
  FaMoneyBillWave,
  FaUserShield,
  FaClock,
} from "react-icons/fa";

function LowerFees() {
  return (
    <>
      <div
        className="feature-style-one-area default-padding bg-gray blurry-shape-right-bottom"
        style={{
          backgroundImage:
            "url(https://validthemes.net/site-template/robok/assets/img/shape/3.png)",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="site-heading">
                <h4 className="sub-title">Our Features</h4>
                <h2 className="title split-text-right split-text-in-right split-lines">
                  Benefits of Crypto Banking
                </h2>
              </div>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="fade-up-anim">
            <div className="row">
              <div className="col-xl-12">
                <div className="feature-style-one-items">
                  {/* 1 */}
                  <div className="feature-style-one">
                    <div className="content d-flex flex-column items-center">
                      <div className="icon">
                        <FaGlobe size={40} />
                      </div>
                      <h4>Financial Inclusion</h4>
                      <p>
                        Crypto banking services are available globally, offering
                        banking solutions to those without access to traditional
                        banks.
                      </p>
                    </div>
                  </div>

                  {/* 2 */}
                  <div className="feature-style-one">
                    <div className="content d-flex flex-column items-center">
                      <div className="icon">
                        <FaMoneyBillWave size={40} />
                      </div>
                      <h4>Lower Fees</h4>
                      <p>
                        Crypto banking transactions often come with lower fees
                        compared to traditional banks, thanks to reduced
                        intermediaries.
                      </p>
                    </div>
                  </div>

                  {/* 3 */}
                  <div className="feature-style-one">
                    <div className="content d-flex flex-column items-center">
                      <div className="icon">
                        <FaUserShield size={40} />
                      </div>
                      <h4>Control Over Assets</h4>
                      <p>
                        Crypto banks provide users with greater control over
                        their finances through decentralized wallets and
                        flexible options.
                      </p>
                    </div>
                  </div>

                  {/* 4 */}
                  <div className="feature-style-one">
                    <div className="content d-flex flex-column items-center">
                      <div className="icon">
                        <FaClock size={40} />
                      </div>
                      <h4>24/7 Access</h4>
                      <p>
                        Users can access their accounts and perform transactions
                        anytime, anywhere due to the digital nature of crypto
                        banking.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default LowerFees;
